var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon",style:({ color: _vm.color }),domProps:{"innerHTML":_vm._s(_vm.icons[_vm.name] || _vm.icons.home)}})
}
var staticRenderFns = []

export { render, staticRenderFns }